module.exports = __webpack_public_path__ + "img/alert.d33a62c6.png";